import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";

export default class ContractingContractAdjustment extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'contractingcontract',
			contractingContractId: props.ContractingContractId,
			data: null,
			loading: false,

			type: 1,
			adjustmentAmount: 0,
			effectiveDate: null,
			reason: ''
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
	}
	save(e) {
		e.preventDefault();

		this.httpPost("api/v1/contractingcontract/save/adjustment", {
			contractingContractId: this.state.contractingContractId,
			effectiveDate: this.convertMomentToDb(this.state.effectiveDate),
			type: this.state.type,
			adjustmentAmount: this.state.adjustmentAmount,
			reason: this.state.reason,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("تعدیل با موفقیت ذخیره شد");

					this.state.caller.refreshData();

					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">تعدیل قرارداد پیمانکاری</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>

							<div className="tab-content">
								<div className="tab-pane active" id="tab1" role="tabpanel">
									<div className="row">
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">جهت تعدیل</label>
												<select onChange={e => this.state.type = parseInt(e.target.value)} defaultValue={this.state.type} className="form-control input-smnumber">
												<option value="1">افزایش</option>
												<option value="2">کاهش</option>
												</select>
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">مبلغ تعدیل</label>
												<input onChange={e => this.state.adjustmentAmount = parseInt(e.target.value)} defaultValue={this.state.adjustmentAmount} type="text" className="form-control input-smnumber ltr" />
											</div>
										</div>
										<div className="col-sm-2">
											<div className="form-group">
												<label for="invoiceDate" className="title1">تاریخ<span className="red">*</span></label>
													<DatePicker
														inputReadOnly={false}
														className="form-control input-sm persian-date"
														placeholder={"تاریخ"}
														isGregorian={false}
														showTodayButton={true}
														timePicker={false}
														onChange={(e) => { this.state.effectiveDate = e }}
														value={this.getFormatedDateForDatePicker(this.state.effectiveDate)}
													/>
											</div>
										</div>
										<div className="col-sm-12">
											<div className="form-group">
												<label for="invoiceNumber" className="title1">علت تعدیل</label>
												<input onChange={e => this.state.reason = e.target.value} defaultValue={this.state.reason} type="text" className="form-control input-smnumber" />
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
						<div className="modal-footer">
							<button type="button" className="hand btn btn-primary" onClick={e => this.save(e)} >ذخیره</button>
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />
		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
			];

		return contents;
	}
}